/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError,
  Video,
  VideoInput,
  Videos,
  VideosParams
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Create new Video
 */
export const createVideo = (
    videoInput: MaybeRefOrGetter<VideoInput>,
 signal?: AbortSignal
) => {
      videoInput = toValue(videoInput);

      return axiosClient<Video>(
      {url: `/videos`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: videoInput, signal
    },
      );
    }




export const getCreateVideoMutationKey = () => ['createVideo'] as const;

export const getCreateVideoMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideo>>, TError,CreateVideoMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createVideo>>, TError,CreateVideoMutationVariables, TContext> => {

const mutationKey = getCreateVideoMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createVideo>>, CreateVideoMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createVideo(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateVideoMutationResult = NonNullable<Awaited<ReturnType<typeof createVideo>>>
    export type CreateVideoMutationBody = VideoInput
    export type CreateVideoMutationError = ErrorType<ValidationError | StandardError>
    export type CreateVideoMutationVariables = {data: VideoInput}

    /**
 * @summary Create new Video
 */
export const useCreateVideo = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createVideo>>, TError,CreateVideoMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createVideo>>,
        TError,
        CreateVideoMutationVariables,
        TContext
      > => {
      return useMutation(getCreateVideoMutationOptions(options), queryClient);
    }
    /**
 * @summary Videos list
 */
export const videos = (
    params?: MaybeRefOrGetter<VideosParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Videos>(
      {url: `/videos`, method: 'GET',
        params, signal
    },
      );
    }




export const getVideosQueryKey = (params?: MaybeRefOrGetter<VideosParams>,) => {
    return [
    'videos', ...(params ? [params] : [])
    ] as const;
    }


export const getVideosQueryOptions = <TData = Awaited<ReturnType<typeof videos>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<VideosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videos>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVideosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof videos>>> = ({ signal }) => videos(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof videos>>, TError, TData>
}

export type VideosQueryResult = NonNullable<Awaited<ReturnType<typeof videos>>>
export type VideosQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Videos list
 */

export function useVideos<TData = Awaited<ReturnType<typeof videos>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<VideosParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof videos>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVideosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Video destroy
 */
export const destroyVideo = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/videos/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVideoMutationKey = () => ['destroyVideo'] as const;

export const getDestroyVideoMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVideo>>, TError,DestroyVideoMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVideo>>, TError,DestroyVideoMutationVariables, TContext> => {

const mutationKey = getDestroyVideoMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVideo>>, DestroyVideoMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyVideo(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVideoMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVideo>>>

    export type DestroyVideoMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyVideoMutationVariables = {id: string}

    /**
 * @summary Video destroy
 */
export const useDestroyVideo = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVideo>>, TError,DestroyVideoMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVideo>>,
        TError,
        DestroyVideoMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyVideoMutationOptions(options), queryClient);
    }
    /**
 * @summary Get Video
 */
export const video = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Video>(
      {url: `/videos/${id}`, method: 'GET', signal
    },
      );
    }




export const getVideoQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'videos',id
    ] as const;
    }


export const getVideoQueryOptions = <TData = Awaited<ReturnType<typeof video>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof video>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVideoQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof video>>> = ({ signal }) => video(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof video>>, TError, TData>
}

export type VideoQueryResult = NonNullable<Awaited<ReturnType<typeof video>>>
export type VideoQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Get Video
 */

export function useVideo<TData = Awaited<ReturnType<typeof video>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof video>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVideoQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Video
 */
export const updateVideo = (
    id: MaybeRefOrGetter<string>,
    videoInput: MaybeRefOrGetter<VideoInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
videoInput = toValue(videoInput);

      return axiosClient<Video>(
      {url: `/videos/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: videoInput, signal
    },
      );
    }




export const getUpdateVideoMutationKey = () => ['updateVideo'] as const;

export const getUpdateVideoMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideo>>, TError,UpdateVideoMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVideo>>, TError,UpdateVideoMutationVariables, TContext> => {

const mutationKey = getUpdateVideoMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVideo>>, UpdateVideoMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateVideo(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVideoMutationResult = NonNullable<Awaited<ReturnType<typeof updateVideo>>>
    export type UpdateVideoMutationBody = VideoInput
    export type UpdateVideoMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateVideoMutationVariables = {id: string;data: VideoInput}

    /**
 * @summary Update Video
 */
export const useUpdateVideo = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVideo>>, TError,UpdateVideoMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVideo>>,
        TError,
        UpdateVideoMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVideoMutationOptions(options), queryClient);
    }
